import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { finagApiUrl } from "../config";
import toast from "react-hot-toast";
import { Logout } from "../Auth/auth";

const getToken = () => {
  const token = localStorage.getItem("token");
  return token;
};

export const getTotalStockValue = createAsyncThunk(
  "getTotalStockValue",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const url = `${finagApiUrl}inventory/products/total-value/`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error("An error occurred");
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          message: "An error occurred while fetching total stock value",
        });
      }
    }
  }
);

export const getMostRequestedProducts = createAsyncThunk(
  "getMostRequestedProducts",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const url = `${finagApiUrl}inventory/products/most-requested/`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error("An error occurred");
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          message: "An error occurred while fetching total stock value",
        });
      }
    }
  }
);

export const getStockMovement = createAsyncThunk(
  "getStockMovement",
  async ({ period }, { rejectWithValue, dispatch }) => {
    try {
      const url = `${finagApiUrl}inventory/products/stock-movement/?period=${period}`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error("An error occurred");
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          message: "An error occurred while fetching stock movement",
        });
      }
    }
  }
);

export const dashBoardStats = createAsyncThunk(
  "dashBoardStats",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const url = `${finagApiUrl}inventory/products/dashboard-stats/`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error("An error occurred");
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          message: "An error occurred while fetching dashboard stats",
        });
      }
    }
  }
);

export const getStockRequestCount = createAsyncThunk(
  "getStockRequestCount",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const url = `${finagApiUrl}inventory/stock-requests/location-summary/`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error("An error occurred");
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          message: "An error occurred while fetching stock request count",
        });
      }
    }
  }
);

export const getStockRequestToDispatch = createAsyncThunk(
  "getStockRequestToDispatch",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const url = `${finagApiUrl}inventory/stock-requests/fulfillment-count/`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error("An error occurred");
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          message: "An error occurred while fetching stock request to dispatch count",
        });
      }
    }
  }
);

export const getInventorySummary = createAsyncThunk(
  "getInventorySummary",
  async (
    { page = 1, page_size = 10, search, status } = {},
    { rejectWithValue, dispatch }
  ) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page);
      params.append("page_size", page_size);
      if (search) params.append("search", search);
      if (status) params.append("status", status);

      const url = `${finagApiUrl}inventory/products/summary/?${params.toString()}`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });

      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error("An error occurred");
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          message: "An error occurred while fetching inventory summary",
        });
      }
    }
  }
);

export const fetchVariantSummary = createAsyncThunk(
  "fetchVariantSummary",
  async ({ variantId }, { rejectWithValue, dispatch }) => {
    try {
      const url = `${finagApiUrl}inventory/products/variant/${variantId}/summary/`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error("An error occurred");
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          message: "An error occurred while fetching variant summary",
        });
      }
    }
  }
);

export const fetchVariantSalesMetrics = createAsyncThunk(
  "fetchVariantSalesMetrics",
  async ({ variantId, period }, { rejectWithValue, dispatch }) => {
    try {
      const url = `${finagApiUrl}inventory/products/variant/${variantId}/sales-metrics/?period=${period}`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error("An error occurred");
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          message: "An error occurred while fetching variant sales metrics",
        });
      }
    }
  }
);

export const fetchSalesPerformancePerStore = createAsyncThunk(
  "fetchSalesPerformancePerStore",
  async (
    { variantId, period, page, page_size },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const url = `${finagApiUrl}inventory/products/variant/${variantId}/sales-by-store/?period=${period}&page=${page}&page_size=${page_size}`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error("An error occurred");
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          message:
            "An error occurred while fetching variant sales performance by stores",
        });
      }
    }
  }
);

export const fetchSalesRecords = createAsyncThunk(
  "fetchSalesRecords",
  async (
    { variantId, status, page, page_size, search },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page);
      params.append("page_size", page_size);
      if (search) params.append("search", search);
      if (status) params.append("status", status);

      const url = `${finagApiUrl}inventory/products/variant/${variantId}/sales-records/?${params.toString()}`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error("An error occurred");
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          message: "An error occurred while fetching variant sales records",
        });
      }
    }
  }
);

export const fetchStockStatusPerStore = createAsyncThunk(
  "fetchStockStatusPerStore",
  async (
    { variantId, status, page, page_size },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const url = `${finagApiUrl}inventory/products/variant/${variantId}/stock-status/?status=${status}&page=${page}&page_size=${page_size}`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error("An error occurred");
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          message: "An error occurred while fetching current status of stock",
        });
      }
    }
  }
);

export const getLowStockProducts = createAsyncThunk(
  "getLowStockProducts",
  async (
    {
      page = 1,
      page_size = 10,
      location_id,
      category,
      search,
      product_type,
    } = {},
    { rejectWithValue, dispatch }
  ) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page);
      params.append("page_size", page_size);
      if (location_id) params.append("location_id", location_id);
      if (category) params.append("category", category);
      if (search) params.append("search", search);
      if (product_type) params.append("product_type", product_type);

      const url = `${finagApiUrl}inventory/products/low-stock/?${params.toString()}`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error("An error occurred");
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          message: "An error occurred while fetching low stock products",
        });
      }
    }
  }
);

export const getActivityLogs = createAsyncThunk(
  "getActivityLogs",
  async (
    {
      page = 1,
      page_size = 20,
      activity_type,
      location_id,
      product_id,
      product_type,
      date_from,
      date_to,
      actor_id,
      search,
    } = {},
    { rejectWithValue, dispatch }
  ) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page);
      params.append("page_size", page_size);
      if (activity_type) params.append("activity_type", activity_type);
      if (location_id) params.append("location_id", location_id);
      if (product_id) params.append("product_id", product_id);
      if (product_type) params.append("product_type", product_type);
      if (date_from) params.append("date_from", date_from);
      if (date_to) params.append("date_to", date_to);
      if (actor_id) params.append("actor_id", actor_id);
      if (search) params.append("search", search);

      const url = `${finagApiUrl}inventory/activities/?${params.toString()}`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error("An error occurred");
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          message: "An error occurred while fetching activity logs",
        });
      }
    }
  }
);

export const getActivityTypes = createAsyncThunk(
  "getActivityTypes",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const url = `${finagApiUrl}inventory/activities/activity_types/`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error("An error occurred");
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          message: "An error occurred while fetching activity types",
        });
      }
    }
  }
);

export const getOutOfStockProducts = createAsyncThunk(
  "getOutOfStockProducts",
  async (
    {
      page = 1,
      page_size = 10,
      location_id,
      category,
      completely_out_of_stock,
      search,
      product_type,
    } = {},
    { rejectWithValue, dispatch }
  ) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page);
      params.append("page_size", page_size);
      if (location_id) params.append("location_id", location_id);
      if (category) params.append("category", category);
      if (completely_out_of_stock !== undefined)
        params.append("completely_out_of_stock", completely_out_of_stock);
      if (search) params.append("search", search);
      if (product_type) params.append("product_type", product_type);

      const url = `${finagApiUrl}inventory/products/out-of-stock/?${params.toString()}`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error("An error occurred");
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          message: "An error occurred while fetching out of stock products",
        });
      }
    }
  }
);

export const fetchVariantsbyProductID = createAsyncThunk(
  "fetchVariantsbyProductID",
  async ({ productId }, { rejectWithValue, dispatch }) => {
    try {
      const url = `${finagApiUrl}inventory/products/variants/${productId}/`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error("An error occurred");
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          message: "An error occurred while fetching variants by product id",
        });
      }
    }
  }
);

export const addInventoryStock = createAsyncThunk(
  "addInventoryStock",
  async ({ variants_stock }, { rejectWithValue, dispatch }) => {
    try {
      const url = `${finagApiUrl}inventory/products/add-stock/`;

      const res = await axios.post(
        url,
        {
          variants_stock: variants_stock,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );
      if (res.status === 200 || res.status === 201) {
        toast.success("Stock added successfully");

        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error(
          error?.response?.data?.message || "Failed to add stock"
        );
        return rejectWithValue(error.response.data);
      } else {
        toast.error("An error occurred while adding stock");
        return rejectWithValue({
          message: "An error occurred while adding stock",
        });
      }
    }
  }
);

export const getStockActivityLogs = createAsyncThunk(
  "getStockActivityLogs",
  async ({ stockId }, { rejectWithValue, dispatch }) => {
    try {
      const url = `${finagApiUrl}inventory/activities/stock/${stockId}/activities/`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else if (error?.response?.data) {
        toast.error("An error occurred");
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          message: "An error occurred while fetching stock activity logs",
        });
      }
    }
  }
);

export const getAllStockRequests = createAsyncThunk(
  "getAllStockRequests",
  async (params = {}, { rejectWithValue, dispatch }) => {
    try {
      const {
        page = 1,
        page_size = 10,
        search = "",
        status = "",
        variantId = "",
      } = params;

      let url = `${finagApiUrl}inventory/stock-requests/all-requests?product_variant_id=${variantId}`;
      const queryParams = new URLSearchParams();

      // Add pagination parameters
      queryParams.append('page', page.toString());
      queryParams.append('page_size', page_size.toString());

      // Add search parameter if provided
      if (search && search.trim() !== "") {
        queryParams.append('search', search.trim());
      }

      // Add status filter parameter if provided and not "All"
      if (status && status.trim() !== "" && status !== "All") {
        // Map frontend status values to backend expected values
        let backendStatus = status;
        switch (status) {
          case "PENDING":
            backendStatus = "pending";
            break;
          case "APPROVED":
            backendStatus = "approved";
            break;
          case "Dispatched":
            backendStatus = "dispatched";
            break;
          case "Confirmed":
            backendStatus = "fulfilled";
            break;
          case "Rejected":
            backendStatus = "cancel";
            break;
          case "PROCESSING":
            backendStatus = "processing";
            break;
          default:
            backendStatus = status.toLowerCase();
        }
        queryParams.append('status_filter', backendStatus);
      }
      // If status is "All" or empty, don't add status_filter parameter

      // Append query parameters to URL
      if (queryParams.toString()) {
        url += `&${queryParams.toString()}`;
      }

      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });

      let allRequests = response.data.data;

      // Map the backend data to match frontend expectations
      const mappedRequests = allRequests.map((request) => ({
        id: request.request_id,
        internal_id: request.id,
        date_requested: new Date(request.created).toLocaleDateString(),
        requested_by:
          request.requested_by?.first_name && request.requested_by?.last_name
            ? `${request.requested_by.first_name} ${request.requested_by.last_name}`
            : request.requested_by?.username || "Unknown",
        product_name:
          request.product_variant?.product_name || "Unknown Product",
        variant_data: {
          type: request.product_variant?.variant_data?.type || "N/A",
          value_unit:
            request.product_variant?.variant_data?.value &&
            request.product_variant?.variant_data?.unit
              ? `${request.product_variant.variant_data.value}${request.product_variant.variant_data.unit}`
              : "N/A",
        },
        quantity: request.quantity_requested,
        approval_status: request.approval_status,
        fulfillment_status: request.fulfillment_status || "PENDING",
        request_type: request.request_type,
        requesting_location: request.requesting_location?.name || "Unknown",
        original: request,
      }));

      const totalItems = response.data.total_items || mappedRequests.length;
      const totalPages = response.data.total_pages || Math.ceil(totalItems / page_size);

      const tabCounts = response.data.tab_counts || {
        All: totalItems, // Add total count for "All" tab
        PENDING: 0,
        PROCESSING: 0,
        APPROVED: 0,
        Dispatched: 0,
        Confirmed: 0,
        Rejected: 0,
      };

      // Return data with backend pagination metadata
      return {
        data: mappedRequests,
        total_items: totalItems,
        current_page: page,
        page_size: page_size,
        total_pages: totalPages,
        tab_counts: tabCounts,
      };
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(Logout());
        return rejectWithValue({ message: "Unauthorized access" });
      } else {
        console.error("API Error:", error.response?.data || error.message);
        toast.error("Failed to fetch stock requests");
        return rejectWithValue({
          message: "An error occurred while fetching stock requests",
        });
      }
    }
  }
);

export const getExpiryAlertCount = createAsyncThunk(
  "getExpiryAlertCount",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const url = `${finagApiUrl}inventory/products/expiry-alert-count/`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      // return custom error message from API if any
      if (error.response.status === 401) {
        dispatch({ type: "auth/Logout" });
      } else if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.response.data);
      }
    }
  }
);

export const getAllExpiryAlert = createAsyncThunk(
  "getAllExpiryAlert",
  async (
    { page = 1, page_size = 10, search = "", status = "" } = {},
    { rejectWithValue, dispatch }
  ) => {
    try {
      const url = `${finagApiUrl}inventory/products/expiry-alerts/?page=${page}&page_size=${page_size}&search=${search}&status=${status}`;
      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      // return custom error message from API if any
      if (error.response.status === 401) {
        dispatch({ type: "auth/Logout" });
      } else if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.response.data);
      }
    }
  }
);

export const getStockValuePerVariant = createAsyncThunk(
  "getStockValueByPerVariant",
  async (variantId, { rejectWithValue, dispatch }) => {
    try {
      const url = `${finagApiUrl}inventory/stock-requests/variant-stock?variant_id=${variantId}`;

      const res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      // return custom error message from API if any
      if (error.response.status === 401) {
        dispatch({ type: "auth/Logout" });
      } else if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.response.data);
      }
    }
  }
);

export const createStockRequest = createAsyncThunk(
  "createStockRequest",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const url = `${finagApiUrl}inventory/stock-requests/create-request/`;

      const res = await axios.post(url, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (res.status === 200) {
        toast.success("Stock request created successfully");
        console.log(res.data);
        return res.data;
      }
    } catch (error) {
      // return custom error message from API if any
      if (error.response.status === 401) {
        dispatch({ type: "auth/Logout" });
      } else if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.response.data);
      }
    }
  }
);
